@if (messages$ | async; as messages) {
  <div>
    @for (
      confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track
      confMsg; let i = $index) {
      <div
        class="alert alert-success"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.SUCCESS"></cx-icon>
        </span>
        <span [innerHTML]="confMsg | cxTranslate | safeHtml" class="text-left alert-message"></span>
        <button
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div
        class="alert alert-info"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.INFO"></cx-icon>
        </span>
        <span [innerHTML]="infoMsg | cxTranslate | safeHtml" class="text-left alert-message"></span>
        <button
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_INFO, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (
      infoMsg of messages[messageType.MSG_TYPE_WARNING]; track
      infoMsg; let i = $index) {
      <div
        class="alert alert-warning"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.WARNING"></cx-icon>
        </span>
        <span [innerHTML]="infoMsg | cxTranslate | safeHtml" class="text-left alert-message"></span>
        <button
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_WARNING, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      <div
        class="alert alert-danger"
        >
        <span class="alert-icon">
          <cx-icon [type]="iconTypes.ERROR"></cx-icon>
        </span>
        <span [innerHTML]="errorMsg | cxTranslate | safeHtml" class="text-left alert-message"></span>
        <button
          class="close"
          type="button"
          (click)="clear(messageType.MSG_TYPE_ERROR, i)"
          >
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
    }
  </div>
}
